'use strict'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { groupBy, uniq } from 'lodash'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'

import DtoUserLayerAssignment from '../../administration/components/user/dto/DtoUserLayerAssignment'
import UserAction from '../../administration/components/user/actions/UserAction'
import AdministrationAction from '../../administration/actions/AdministrationAction'
import User from '../../account/dto/User'
import { allLayersProps } from './constants/MapLayersConstants'
import WatershedDto from '../../referencial/components/watershed/dto/WatershedDto'
import { setLayersOpacity } from './mapTreatments/AddingLayers'
import { Accordion, AccordionDetails, Card, CardContent, Grid2, Slider, Tooltip } from '@mui/material'
import Checkbox from '../forms/Checkbox'
import LayerDto from 'home/dto/LayerDto'
import { parseNowVariableURL } from '../../utils/UrlUtils'
import { getLogin, getSetting, getSettingJson } from '../../utils/SettingUtils'
import SieauParameterDto from '../../administration/dto/SieauParameterDto'
import SettingDto from '../../administration/dto/SettingDto'
import { homeListOfLayersOpacity, homeListOfSelectedLayers } from 'carto/constants/CartoConstants'
import AccountAction from 'account/actions/AccountAction'
import moment from 'moment'
import { CardTitle } from 'components/card/NewCard'
import { darkBlue } from 'utils/constants/ColorTheme'
import { AccordionTitle } from 'components/styled/Accordions'
import CartographyThemeDto from 'administration/dto/CartographyThemeDto'

const TYPE_PARAMS = ['all', 'showAll', 'alerts', 'territory', 'specificUser']

class CartographyControlPanel extends Component {
    state = {
        layersOpacity: {},
        dataLoaded: false,
        layersId: [],
    }

    componentDidMount() {
        const { usersThemes, login } = this.props

        this.props.fetchSettings(login ?? getLogin()).then(() => {
            this.setLayersState()
        })
        this.setLayersState()

        if (!usersThemes.length) {
            this.props.fetchUsersAssign()
        }

        this.props.fetchCartoThemes()
    }

    changeVisible = (layerName, id, save = false) => {
        const { visible, settings, componentType } = this.props
        const { layersOpacity, layersId } = this.state
        const newValue = !(visible[layerName] || false)
        if (componentType === 'homepage') {
            const obj = { [layerName]: { enabled: newValue } }
            this.props.setSelectedSearchValues('dashboardCheckboxes', obj)
        }
        this.props.onChangeVisible([layerName])
        if (layersOpacity[layerName]) {
            setLayersOpacity([{ name: layerName, opacity: layersOpacity[layerName] }])
            this.setState({ layersId: [
                ...layersId,
                id,
            ] }, () => save && this.saveCartographyLayers([id]))
        } else if (this.props.visible[layerName]) {
            setLayersOpacity([{ name: layerName, opacity: 0 }])
            this.setState({
                layersOpacity: {
                    ...layersOpacity,
                    [layerName]: 0,
                },
                layersId: [
                    ...layersId,
                    id,
                ],
            }, () => save && this.saveCartographyLayers([id]))
        } else if (!visible[layerName]) {
            const opacitySaved = (getSettingJson(settings, homeListOfLayersOpacity) || []).find((v) => v.layerName === layerName)
            const opacity = opacitySaved?.opacity ? opacitySaved.opacity : 1
            setLayersOpacity([{ name: layerName, opacity }])
            this.setState({
                layersOpacity: {
                    ...layersOpacity,
                    [layerName]: opacity,
                },
                layersId: [
                    ...layersId,
                    id,
                ],
            }, () => save && this.saveCartographyLayers())
        }
    }

    getNewOpacity = (layer) => {
        const { visible, settings } = this.props
        const { layersOpacity } = this.state
        const visibleFound = visible[layer.layer]
        const layerOpacity = layersOpacity[layer.layer]
        if (layerOpacity) {
            return layerOpacity
        } else if (visibleFound) {
            return 0
        }
        const opacitySaved = (getSettingJson(settings, homeListOfLayersOpacity) || []).find((v) => v.layerName === layer.layer)
        return opacitySaved?.opacity ? opacitySaved.opacity : 1
    }

    changeVisibleAll = (layers, isAllChecked) => {
        const { componentType, visible } = this.props
        const { layersId, layersOpacity } = this.state
        this.props.onChangeVisible(layers.map(l => l.layer), !isAllChecked)
        if (componentType === 'homepage') {
            const newDashboardObj = layers.reduce((acc, l) => ({ ...acc, [l.layer]: { enabled: !(visible[l.layer] || false) } }), {})
            this.props.setSelectedSearchValues('dashboardCheckboxes', newDashboardObj)
        }
        const ids = layers.map(l => l.id)
        const newLayersOpacity = layers.map(l => ({
            ...l,
            opacity: this.getNewOpacity(l),
        }))
        const newLayersOpacityObj = newLayersOpacity.reduce((acc, l) => ({ ...acc, [l.layer]: l.opacity }), {})
        this.setState({ layersId: [ ...layersId, ...ids ], layersOpacity: { ...layersOpacity, ...newLayersOpacityObj } })
        setLayersOpacity(newLayersOpacity)
        this.saveCartographyLayers(ids, isAllChecked)
    }

    getLegend = (url, layerName) => {
        if (url.includes('#MYMAPS/')) {
            const test = `${parseNowVariableURL(url, getSetting(this.props.applicationSettings, 'myMaps'))}&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&format=image/jpeg&layer=${layerName}`
            return test
        }
        const urlLower = url.toLowerCase()
        return `${url}${urlLower.indexOf('?') >= 0 ? urlLower.indexOf('version') >= 0 ? '' : 'version=1.3.0' : '?version=1.3.0'}&service=WMS&request=GetLegendGraphic&sld_version=1.1.0&format=image/jpeg&layer=${layerName}`
    }

    getSwitch = (layer, label) => {
        const { layer: layerName, id } = layer
        const legend = layer.url ? this.getLegend(layer.url, layerName) : null
        const opacitySaved = (getSettingJson(this.props.settings, homeListOfLayersOpacity) || []).find((v) => v.layerName === layerName)
        return (
            <div className='switch row'>
                <label>
                    <div className='row no-margin valign-wrapper'>
                        <div className={`col s${legend ? 1 : 2}`}>
                            <div onClick={e => {
                                e.preventDefault()
                                this.changeVisible(layerName, id, true)
                            }}
                            >
                                <Checkbox checked={ this.props.visible[layerName] } />
                            </div>
                        </div>
                        <div className='col s8'>
                            { label }
                        </div>
                        <Slider
                            className='col s2 no-margin'
                            sliderStyle={{ margin: 0 }}
                            style={{ margin: 0 }}
                            min={0}
                            max={1}
                            step={0.1}
                            value={ this.state.layersOpacity[layerName] || (this.props.visible[layerName] ? (opacitySaved?.opacity || 1) : 0) }
                            onChange={(event, value) => {
                                setLayersOpacity([{ name: layerName, opacity: value }])
                                this.setState({
                                    layersOpacity: {
                                        ...this.state.layersOpacity,
                                        [layerName]: value,
                                    },
                                })
                            }}
                            onChangeCommitted={(e, v) => this.saveLayersOpacity(layerName, v)}
                        />
                        { legend ? <div className='col s1'>
                            <Tooltip
                                placement='left-start'
                                arrow
                                PopperProps={{
                                    disablePortal: true,
                                }}
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            maxWidth: 'fit-content',
                                            width: 'fit-content',
                                        },
                                    },
                                }}
                                title={
                                    <>
                                        <img src={legend} alt={layerName} />
                                    </>}
                            >
                                <div id='fancy' className='material-icons'>
                                    info_outline
                                </div>
                            </Tooltip>
                        </div> : null }
                    </div>
                    {!!layer.source && (
                        <div className='row no-margin valign-wrapper'>
                            <div className={`col s${legend ? 1 : 2}`} />
                            <div className='col s11'>
                                <i style={{ fontSize: '11px' }}>{i18n.source}: { layer.source }</i>
                            </div>
                        </div>
                    )}
                </label>
            </div>
        )
    }

    getThemeLayersSwichs = () => {
        const { usersThemes, login = getLogin(), themeLayers, allcartographyThemes, componentType, visible } = this.props
        const newLayers = usersThemes.filter(th => th.login === login)
        const themeGroups = groupBy(themeLayers, 'theme')
        if (themeGroups && themeLayers.length) {
            const themeList = allcartographyThemes.filter(theme =>
                (TYPE_PARAMS.includes(componentType) || newLayers.some(th => th.themeId === theme.id && th[componentType]))
                && newLayers.some(th => th.themeId === theme.id && th.visibility),
            )
                .filter(theme => themeGroups[theme.id])
            return themeList.map(theme => {
                const themeGroup = themeGroups[theme.id]
                const isAllChecked = !themeGroup.some((l) => !visible[l.layer])
                return (
                    <Grid2 key={theme.id}>
                        <Accordion>
                            <AccordionTitle
                                title={(
                                    <Grid2 container>
                                        <Checkbox
                                            checked={isAllChecked}
                                            className='white-checkbox'
                                            onChange={() => {
                                                this.changeVisibleAll(themeGroup, isAllChecked)
                                            }}
                                            containerStyle={{ display: 'flex', alignItems: 'center' }}
                                            stopPropagation
                                        />
                                        {theme.name}
                                    </Grid2>
                                )}
                                color={theme.color}
                            />
                            <AccordionDetails>
                                {themeGroup.map(layer => this.getSwitch(layer, layer.name))}
                            </AccordionDetails>
                        </Accordion>
                    </Grid2>
                )
            })
        }
        return null
    }

    saveCartographyLayers = (newLayers = [], isAllChecked) => {
        const { login = getLogin(), settings } = this.props
        const { layersId } = this.state
        const layers = (newLayers.length <= 1 || isAllChecked) ? layersId.filter(l => !newLayers.includes(l)) : uniq([...newLayers, ...layersId])
        this.setState({ layersId: layers })
        const filterSettings = settings.filter(o => o.parameter !== homeListOfSelectedLayers)
        const newSettings = [ ...filterSettings, {
            login,
            parameter: homeListOfSelectedLayers,
            updateDate: moment().valueOf(),
            value: layers.join() || '',
        }]
        this.props.updateSettingUser(login, newSettings)
    }

    saveLayersOpacity = (layerName, opacity) => {
        const { login = getLogin(), settings } = this.props
        const opacitySettings = getSettingJson(settings, homeListOfLayersOpacity) || []
        const layersOpacityJson = JSON.stringify([
            ...opacitySettings.filter((s) => s.layerName !== layerName),
            { layerName, opacity },
        ])
        const filterSettings = settings.filter(o => o.parameter !== homeListOfLayersOpacity)
        const newSettings = [ ...filterSettings, {
            login,
            parameter: homeListOfLayersOpacity,
            updateDate: moment().valueOf(),
            value: layersOpacityJson,
        }]
        this.props.updateSettingUser(login, newSettings)
    }

    getSelectedLayersParameter = () => {
        const { settings } = this.props
        const selectedLayersParameter = settings.find(s => s.parameter === homeListOfSelectedLayers)?.value
        return selectedLayersParameter
    }

    getCartographyLayers = () => {
        const selectedLayersParameter = this.getSelectedLayersParameter()
        if (selectedLayersParameter?.length) {
            return selectedLayersParameter
        }
        return ''
    }

    setLayersState = () => {
        const stringLayers = this.getCartographyLayers()
        const layers = stringLayers.length > 0 ? stringLayers.split(',').map(item => parseInt(item, 10)) : []
        const obj = layers.reduce((a, v) => {
            const layerName = this.props.themeLayers.find(l => l && l.id === parseInt(v))?.layer
            const opacitySaved = (getSettingJson(this.props.settings, homeListOfLayersOpacity) || []).find((s) => s.layerName === layerName)
            const opacity = opacitySaved?.opacity ? opacitySaved.opacity : 1
            setLayersOpacity([{ name: layerName, opacity }])
            return ({ ...a, [layerName]: opacity })
        }, {})
        this.setState({ layersOpacity: obj, dataLoaded: true, layersId: layers })
    }

    getBaseLayers = () => {
        const { layers, exists } = this.props
        return layers
            .filter(layer => exists[layer] && !['STATIONS_POINTS', 'STATION'].includes(layer))
            .map(layer => this.getSwitch(new LayerDto({ layer }), allLayersProps(this.props)[layer].name))
    }

    render() {
        const { dataLoaded } = this.state
        if (dataLoaded) {
            const baseLayers = this.getBaseLayers()
            const themeLayers = this.props.withThemeLayers ? this.getThemeLayersSwichs() : null
            return (
                <Grid2 container spacing={1} direction='column'>
                    <Card>
                        <CardTitle title={i18n.mapLayers} color={darkBlue} />
                        <CardContent>
                            { baseLayers }
                        </CardContent>
                    </Card>
                    { themeLayers }
                </Grid2>

            )
        }
        return null
    }
}

CartographyControlPanel.propTypes = {
    station: PropTypes.shape({}),
    componentType: PropTypes.string.isRequired,
    visible: PropTypes.shape({
        DISTRIBUTION_UNIT: PropTypes.bool,
        HYDROMETRIC_STATION: PropTypes.bool,
        INSTALLATION: PropTypes.bool,
        PIEZOMETER: PropTypes.bool,
        PLUVIOMETER: PropTypes.bool,
        PRODUCTION_UNIT: PropTypes.bool,
        QUALITOMETER: PropTypes.bool,
        installationType0: PropTypes.bool,
        installationType1: PropTypes.bool,
        installationType2: PropTypes.bool,
        installationType3: PropTypes.bool,
        installationType4: PropTypes.bool,
        installationType5: PropTypes.bool,
        installationType6: PropTypes.bool,
        installationType7: PropTypes.bool,
        installationType8: PropTypes.bool,
        installationType9: PropTypes.bool,
        installationType10: PropTypes.bool,
        installationType11: PropTypes.bool,
        installationType12: PropTypes.bool,
        installationType13: PropTypes.bool,
        installationType14: PropTypes.bool,
        installationType16: PropTypes.bool,
        installationType17: PropTypes.bool,
        installationType18: PropTypes.bool,
        installationType20: PropTypes.bool,
        'installationType-1': PropTypes.bool,
        qualitometerType0: PropTypes.bool,
        qualitometerType1: PropTypes.bool,
        qualitometerType2: PropTypes.bool,
        qualitometerType3: PropTypes.bool,
        qualitometerType4: PropTypes.bool,
        qualitometerType5: PropTypes.bool,
        qualitometerType6: PropTypes.bool,
        qualitometerType7: PropTypes.bool,
        qualitometerType8: PropTypes.bool,
    }),
    exists: PropTypes.shape({}),
    onChangeStationKMLExists: PropTypes.func,
    onChangeVisible: PropTypes.func,
    oneThemeLayer: PropTypes.shape({}),
    watermass: PropTypes.string,
    layers: PropTypes.arrayOf(PropTypes.shape({})),
    withThemeLayers: PropTypes.bool,
    stationWatershed: PropTypes.instanceOf(WatershedDto),
    watershed1: PropTypes.instanceOf(WatershedDto),
    watershed2: PropTypes.instanceOf(WatershedDto),
    watershed3: PropTypes.instanceOf(WatershedDto),
    watershed4: PropTypes.instanceOf(WatershedDto),
    usersThemes: PropTypes.arrayOf(PropTypes.instanceOf(DtoUserLayerAssignment)),
    accountUser: PropTypes.instanceOf(User),
    applicationSettings: PropTypes.arrayOf(PropTypes.instanceOf(SieauParameterDto)),
    fetchSettings: PropTypes.func,
    updateSettingUser: PropTypes.func,
    settings: PropTypes.arrayOf(PropTypes.instanceOf(SettingDto)),
    login: PropTypes.string,
    fetchUsersAssign: PropTypes.func,
    fetchCartoThemes: PropTypes.func,
    themeLayers: PropTypes.arrayOf(PropTypes.instanceOf(LayerDto)),
    allcartographyThemes: PropTypes.arrayOf(PropTypes.instanceOf(CartographyThemeDto)),
    setSelectedSearchValues: PropTypes.func,
}

const mapStateToProps = store => ({
    stationWatershed: store.WatershedReducer.stationWatershed,
    allcartographyThemes: store.AdministrationReducer.adminThemes,
    usersThemes: store.UserReducer.usersThemes,
    accountUser: store.AccountReducer.accountUser,
    watershed1: store.WatershedReducer.watershed1,
    watershed2: store.WatershedReducer.watershed2,
    watershed3: store.WatershedReducer.watershed3,
    watershed4: store.WatershedReducer.watershed4,
    applicationSettings: store.AdministrationReducer.applicationSettings,
    settings: store.AdministrationReducer.userSettings,
    themeLayers: store.HomeReducer.themeLayers,
})

const mapDispatchToProps = {
    fetchSettings: AdministrationAction.fetchUserSettings,
    updateSettingUser: AccountAction.updateSettings,
    fetchCartoThemes: AdministrationAction.fetchAdminCartographyThemes,
    fetchUsersAssign: UserAction.fetchUsersThemesAssignment,
    setSelectedSearchValues: AdministrationAction.setSelectedSearchValues,
}

export default connect(mapStateToProps, mapDispatchToProps)(CartographyControlPanel)
